export const TRACE_DEFAULT_COLOR = '#5f73a1';
export const COMPLETED_TRACE_COLOR = '#52c41a';
